export default __webpack_public_path__ + "static/media/coffee.96113362.ogg";